import axios from "services/api";
import { API2_HOST } from 'helpers/urlHelper';

/**
 * Uploads multiple files and maps them to a record in a single request.
 * @param {Object} params 
 * @param {File[]} params.files - Array of File objects
 * @param {string} params.bucketName - S3 Bucket name (e.g., 'eva-files')
 * @param {string} params.app - Application/Step name
 * @param {string} params.prefix - S3 Key prefix
 * @param {number} params.recordId - Numeric ID of the record
 * @param {string} params.recordValue - String value of the record (e.g., GRN number)
 */
export const uploadMultipleAndMap = async ({
  files,
  bucketName,
  app,
  prefix,
  recordId,
  recordValue,
  notes = '',
  ediType = ''
}) => {
  const formData = new FormData();

  files.forEach(file => {
    formData.append('files', file);
  });

  formData.append('bucketName', bucketName);
  formData.append('app', app);
  formData.append('prefix', prefix);
  formData.append('recordId', recordId);
  formData.append('recordValue', recordValue || '');
  formData.append('notes', notes);
  formData.append('ediType', ediType);

  const res = await axios({
    url: `${API2_HOST}/files/multi-upload-and-map`,
    method: 'POST',
    data: formData,
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  });

  return res;
};
